import { STUDY_LAB_ACCEPTANCE_STATUS } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const studyLabAcceptanceStatus = createAsyncThunk('studyLabAcceptanceStatus', async (body:any) => {
  try {
    let url = STUDY_LAB_ACCEPTANCE_STATUS
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(body)
    })

     // Check for HTTP errors
    if (!response.ok) {
      const error = await response.json(); // Parse error response if available
      throw new Error(`HTTP error! status: ${response.status}, message: ${error.message || response.statusText}`);
    }
    return await response.json()

  } catch (error) {
    throw error;
  }
});

export default studyLabAcceptanceStatus;
